import { n as downloadCargoFlowsTemplate, t as getDictionaries } from "./getDictionaries.js";
import { queryOptions, useQuery } from "@tanstack/react-query";
//#region src/__generated__/external/dictionaries/hooks/useDownloadCargoFlowsTemplate.ts
const downloadCargoFlowsTemplateQueryKey = () => [{ url: "/api/mdm/external/api/external/dictionaries/cargo-flows-template" }];
function downloadCargoFlowsTemplateQueryOptions(config = {}) {
	const queryKey = downloadCargoFlowsTemplateQueryKey();
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await downloadCargoFlowsTemplate({
				...config,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Скачать шаблон грузопотоков (xlsx)
* {@link /api/mdm/external/api/external/dictionaries/cargo-flows-template}
*/
function useDownloadCargoFlowsTemplate(options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = resolvedOptions?.queryKey ?? downloadCargoFlowsTemplateQueryKey();
	const queryResult = useQuery({
		...downloadCargoFlowsTemplateQueryOptions(config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/external/dictionaries/hooks/useGetDictionaries.ts
const getDictionariesQueryKey = () => [{ url: "/api/mdm/external/api/external/dictionaries" }];
function getDictionariesQueryOptions(config = {}) {
	const queryKey = getDictionariesQueryKey();
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getDictionaries({
				...config,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Форма заявки: виды обращения, работы, примыкание, финансирование,
* типы заявителя, дороги.
* Фильтры таблицы: те же дороги и виды обращения плюс статусы и признаки
* обработки. Здесь только закрытые наборы значений; Оператор и Инициатор
* собираются из данных — GET /api/external/operator/requests/filter-values.
* @summary Справочники формы заявки и фильтров таблицы
* {@link /api/mdm/external/api/external/dictionaries}
*/
function useGetDictionaries(options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = resolvedOptions?.queryKey ?? getDictionariesQueryKey();
	const queryResult = useQuery({
		...getDictionariesQueryOptions(config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
export { downloadCargoFlowsTemplateQueryOptions as a, downloadCargoFlowsTemplateQueryKey as i, getDictionariesQueryOptions as n, useDownloadCargoFlowsTemplate as o, useGetDictionaries as r, getDictionariesQueryKey as t };

//# sourceMappingURL=useGetDictionaries.js.map